import jwtDecode from 'jwt-decode'

// this should be an api call but for now we just hard code
const PAGE_PERMISSIONS = {
  '/login': [
    1,
    2,
    3,
    4,
    6,
    5
  ],
  '/admin': [
    1,
    2,
    3,
    6
  ],
  '/configuration': [
    1,
    2,
    3,
    6
  ],
  '/asTechs': [
    1,
    2,
    3,
    4,
    6,
    5
  ]
}

export default {
  token: state => state.token,
  passthrough: state => state.passthrough,
  user: state => state.token ? jwtDecode(state.token) : {},
  isAllowed: (state) => {
    return (page = '') => {
      if (!PAGE_PERMISSIONS[page]) { return true }
      if (state.profile.roles && state.profile.roles.length) {
        return state.profile.roles.some(r => PAGE_PERMISSIONS[page].includes(r))
      }
      return PAGE_PERMISSIONS[page].includes('Guest')
    }
  },
  userProfile: state => state.userProfile,
  userToken: state => state.userToken,
  userInfo: state => state.userInfo,
  roles: state => state.roles,
  profile: state => state.profile,
  businessUsers: state => state.businessUsers,
  isLogout: state => state.isLogout,
  languages: state => state.languages,
  language: state => state.language,
  channelType: state => state.channelType
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js